export function slugify(title: string) {
  const base = (title || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
  return base || `materia-${Date.now()}`
}

export function makeExcerpt(body: string, max = 140) {
  const text = (body || '').replace(/\s+/g, ' ').trim()
  if (!text) return ''
  if (text.length <= max) return text
  return `${text.slice(0, max).trim()}...`
}

const CATEGORY_RULES: { category: string; keywords: string[] }[] = [
  { category: 'Política', keywords: ['prefeito', 'prefeitura', 'vereador', 'camara', 'eleicao', 'governo', 'deputado', 'partido', 'politica', 'alvara'] },
  { category: 'Educação', keywords: ['escola', 'aluno', 'professor', 'universidade', 'educacao', 'aula', 'matricula', 'pedagog'] },
  { category: 'Trânsito', keywords: ['transito', 'acidente', 'rodovia', 'blitz', 'motorista', 'prf', 'detran', 'velocidade', 'estrada'] },
  { category: 'Saúde', keywords: ['saude', 'hospital', 'ubs', 'medico', 'vacina', 'posto de saude', 'paciente'] },
  { category: 'Esporte', keywords: ['futebol', 'campeonato', 'jogo', 'time', 'esporte', 'atleta', 'olimpi'] },
  { category: 'Cultura', keywords: ['festa', 'show', 'cultura', 'musica', 'teatro', 'forro', 'tradicao'] },
  { category: 'Segurança', keywords: ['policia', 'assalto', 'crime', 'seguranca', 'pm ', 'bombeiro'] },
  { category: 'Economia', keywords: ['comercio', 'emprego', 'economia', 'feira', 'loja', 'preco'] },
  { category: 'Clima', keywords: ['chuva', 'seca', 'clima', 'tempo', 'barragem'] },
]

function normalize(text: string) {
  return (text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

export function detectCategory(title: string, body = '') {
  const hay = `${normalize(title)} ${normalize(body)}`
  const found = CATEGORY_RULES.find((rule) => rule.keywords.some((word) => hay.includes(word)))
  return found?.category || 'Geral'
}

export function formatNewsDate(iso?: string) {
  if (!iso) return ''
  try {
    return new Date(iso).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
  } catch {
    return ''
  }
}

export function articlePath(slug: string) {
  return `/noticias/${slug}`
}

function decodeHtml(text: string) {
  return text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&apos;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&amp;/gi, '&')
}

export function splitNewsBody(body?: string) {
  const raw = decodeHtml((body || '').replace(/\r\n/g, '\n')).trim()
  if (!raw) return []
  const withoutTags = raw
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<\/h[1-6]>/gi, '\n')
    .replace(/<[^>]+>/g, ' ')
  const parts = withoutTags
    .split(/\n+/)
    .map((part) => part.replace(/\s+/g, ' ').trim())
    .filter(Boolean)
  if (parts.length) return parts
  const fallback = withoutTags.replace(/\s+/g, ' ').trim()
  return fallback ? [fallback] : []
}
